import PropTypes from "prop-types";

import { Button } from "../../../../core/buttons";

function Buttons({ onNo, onYes }) {
  return (
    <>
      <Button
        onClick={onYes}
        className="
          w-full
          text-white
          bg-primary-green
          border-primary-green
          hover:bg-white
          active:bg-white
          hover:text-primary-green
          active:text-primary-green
        "
      >
        yes, let's go!
      </Button>
      <Button
        onClick={onNo}
        className="
          w-full
          bg-white
          text-primary-green
          border-primary-green
          hover:text-white
          active:text-white
          hover:bg-primary-green
          active:bg-primary-green
        "
      >
        no, i need some help
      </Button>
    </>
  );
}

Buttons.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired
};

export default Buttons;
